import axios, { AxiosInstance } from 'axios';
import { FronteggContext } from '@frontegg/rest-api';

function attachInterceptorsWithFronteggToken(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.request.use((config) => {
    let token = FronteggContext.getAccessToken();

    const headers: Record<string, string> = {
      Accept: 'application/json',
      Authorization: `Bearer ${token || null}`,
      'Content-Type': 'application/json',
    };

    Object.entries(headers).forEach(([key, value]) => {
      if (!config.headers[key]) {
        config.headers[key] = value;
      }
    });

    return config;
  });

  axiosInstance.defaults.headers.common = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
}

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

export const ambientApi = axios.create({
  baseURL: import.meta.env.VITE_AMBIENT_API_BASE_URL,
});

export const adminApi = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_API_BASE_URL,
});

export const integrationsApi = axios.create({
  baseURL: import.meta.env.VITE_INTEGRATIONS_API_BASE_URL,
});

export const aivaApi = axios.create({
  baseURL: import.meta.env.VITE_PHONE_TRIAGE_API_BASE_URL,
});

export const fronteggApi = axios.create({
  baseURL: `${import.meta.env.VITE_FRONTEGG_BASE_URL}/frontegg`,
});

[api, ambientApi, adminApi, integrationsApi, aivaApi, fronteggApi].forEach(
  attachInterceptorsWithFronteggToken
);
